import { render, staticRenderFns } from "./InsectList.vue?vue&type=template&id=adcf8b8c&scoped=true&"
import script from "./InsectList.vue?vue&type=script&lang=js&"
export * from "./InsectList.vue?vue&type=script&lang=js&"
import style0 from "./InsectList.vue?vue&type=style&index=0&id=adcf8b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcf8b8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCol,VDataTable,VIcon})
